import { IOptionValueQuestionGroup } from "./interfaces/option-value-question-group";
import { IOptionValue } from "./interfaces/option-value";
import { IQuestionGroup } from "./interfaces/question.group";

export class OptionValueQuestionGroup implements IOptionValueQuestionGroup {
  constructor(
    optionValueId?: number,
    questionGroupId?: number,
    questionGroup?: IQuestionGroup) {
    this.questionGroup = questionGroup != undefined ? questionGroup : null;
    this.questionGroupId = questionGroupId != undefined ? questionGroupId : 0;
    this.optionValueId = optionValueId != undefined ? optionValueId : 0;
  }

  optionValueId: number;
  questionGroupId: number;
  index: number;
  isDeleted: boolean;
  optionValue: IOptionValue;
  questionGroup: IQuestionGroup | null;

  prepare(): void {
    if (this.index < 1) {
      this.index = 1;
    }

    this.optionValue.prepare();
    if (this.questionGroup) {
      this.questionGroup.prepare();
    }
  }

  isValid(): boolean {
    if (this.questionGroup) {
      return this.questionGroupId > 0 && this.index > 0 && this.optionValue.isValid() && this.questionGroup.isValid();
    }
    return this.questionGroupId > 0 && this.index > 0 && this.optionValue.isValid();
  }
}
